import { dialogsTestIds } from "../../../../../utility/tests/testId/dialogs"

export const CONTEXT_TRANSLATE_INFO_KEY = "translate_info"
export const MESSAGE_LANGUAGE_SLOT_ID = "message_language"
export const DIALOG_TRANSLATION_BUTTONS_LOCALES = {
    tNamespace: "dialogs",
    tPaths: {
        toggleTooltip: "translation-actions.toggle-tooltip",
        noLanguages: "translation-actions.no-languages"
    },
    testIds: {
        toggle: dialogsTestIds.dialogAutoTranslateToggle,
        languageDropdown: dialogsTestIds.dialogTranslateLanguageDropdown,
        contextLoader: dialogsTestIds.dialogTranslateContextLoader
    }
}
